import React, { useEffect, useState } from 'react'

import { getPaymentMethods } from '../../../api'
import {
    JsonPaymentMethod,
    PaymentMethod,
    RecordStatus,
} from '../../../models'
import { RecordStatusFilters } from '../../records/filters'

interface FilterProps {
    updateFilters: (
        filterName: string,
        newValue: string | null,
        shouldDelete?: boolean
    ) => void
}

export const DailyPaymentFilters: React.FC<FilterProps> = ({ updateFilters }) => {
    const [paymentMethods, setPaymentMethods] = useState<PaymentMethod[]>([])

    useEffect(() => {
        getPaymentMethods().then((json) => {
            const methods = json.data.map(
                (method: JsonPaymentMethod) => new PaymentMethod(method)
            )
            setPaymentMethods(methods)
        })
    }, [])

    const updateFiltersWrapper = (
        filterName: string,
        newValue: string,
        shouldDelete?: boolean,
        dependentFilterToClear?: string
    ) => {
        updateFilters(filterName, newValue, shouldDelete)

        if (dependentFilterToClear) {
            updateFilters(dependentFilterToClear, '', true)
        }
    }

    // Filter to show only paid statuses for payments page
    const paidStatusFilter = (status: RecordStatus) => {
        return RecordStatus.PAID_STATUSES.includes(status.code)
    }

    return (
        <>
            <RecordStatusFilters
                updateFilters={updateFiltersWrapper}
                statusFilter={paidStatusFilter}
            />
            <label htmlFor="paymentMethodFilter">Payment Method</label>
            <select
                className="form-select"
                id="paymentMethodFilter"
                onChange={(e) =>
                    updateFilters(
                        'payment_method_id',
                        e.target.value === '-1' ? '' : e.target.value
                    )
                }
            >
                <option value={-1}>All</option>
                <option value="none">No Payment Method</option>
                {paymentMethods.map((method: PaymentMethod) => (
                    <option key={method.id} value={method.id}>
                        {method.name}
                    </option>
                ))}
            </select>
        </>
    )
}
